import $ from 'jquery';

$(function(){
    $('.mobile-nav-trig').on('click', function(){
        console.log('HEY');
        $('.nav').slideToggle();
    });
});

